import React, { Component } from 'react';
import { Router, Route } from 'react-router-dom';
import i18next from 'i18next'
import { BehaviorSubject } from 'rxjs';

import { history } from './Authorization/_helpers';
import { authenticationService } from './Authorization/_services';
import { PrivateRoute } from './Authorization/_components';
import { localization} from './Frames/localization'

import {messageWindow} from './Elements/Snackbar/MessageWindow'
import {messageWindowFixed} from './Elements/Snackbar/fixedMessageWindow'


import { ThemeProvider } from "@material-ui/styles";

import Navigation from './Frames/navigation/navigation'
import Login from './Authorization/Login'

import Stats from './Statistics/stats'
import Operations from './Statement/operations'
import ClientInfo from './Profile/clientInfo'
import Security from './Security/security'
import About from './About/about'
import Limits from './CardLimit/limits'
import Cashback from './CashBack/cashback'
import TextField from '@material-ui/core/TextField';
import {
    withStyles, createMuiTheme
  } from '@material-ui/core/styles';
  import OutlinedInput from '@material-ui/core/OutlinedInput';
  import Switch from '@material-ui/core/Switch';
  import LinearProgress from '@material-ui/core/LinearProgress';

import './App.css';
const baseUrl = process.env.PUBLIC_URL;
const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));
class App extends Component  {
    constructor(props) {
        super(props);
        this.state = {
            theme: localStorage.getItem('theme')==null ? "light":localStorage.getItem('theme'),
            selectedIndex: 0,
            activeArticleId: 1,
            currentUser: null,
            settingsIsLoad: false,
            keyFixed: undefined,
        };
        this.toggleTheme = this.toggleTheme.bind(this);
        this.switchArticle = this.switchArticle.bind(this);
        this.updateUserName = this.updateUserName.bind(this);
        this.closefixedMessage = this.closefixedMessage.bind(this);

        this.setSelectedIndex = this.setSelectedIndex.bind(this);
    }
    closefixedMessage()
    {
        messageWindowFixed.CloseMessage()
        this.setState({keyFixed: Math.random()})
        this.forceUpdate()
    }
    updateUserName()
    {
      const requestOptionsExit = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify("")
    }
      fetch(`/api/getclientinfo`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
            if(response.data == null){
                messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                this.setState({key: Math.random(),open: true})
            }
            else
            {
              this.state.currentUser.data.name = response.data.res.clientIdDesc;
              localStorage.setItem('currentUser', JSON.stringify(this.state.currentUser));
              currentUserSubject.next(this.state.currentUser);
              this.forceUpdate()
            }             
        })
        
    }
    scroll_num(data)
    {
      switch(data)
      {
        case 0: return 10;
        case 1: return 25;
        case 2: return 100;
      }
    }
    location_alert(value)
    {
      /*
      {
              vertical: this.location_alert('bottom'),
              horizontal: this.location_alert('left'),
            },
      */
      switch(value)
      {
        case 0: return {
            vertical: 'top',
            horizontal: 'left',
          }
        case 1: return {
          vertical: 'top',
          horizontal: 'center',
        }
        case 2: return {
          vertical: 'top',
          horizontal: 'right',
        }
        case 3: return {
          vertical: 'bottom',
          horizontal: 'left',
        }
        case 4: return {
          vertical: 'bottom',
          horizontal: 'center',
        }
        case 5: return {
          vertical: 'bottom',
          horizontal: 'right',
        }
        default:
          return {
            vertical: 'bottom',
            horizontal: 'left',
          }
      }
    }
    MethodAppliedSettings(fetchdata, data, loginMask)
    {
      AppliedSettings = {
        //view_navigation_settings
            show_statistics_page: Boolean(data.show_statistics_page),
            show_operations_page: Boolean(data.show_operations_page),
            show_clientInfo_page: Boolean(data.show_clientInfo_page),
            show_security_page: Boolean(data.show_security_page),
            show_limits_page: Boolean(data.show_limits_page),
            show_cashback_page: Boolean(data.show_cashback_page),
            show_night_thema: Boolean(data.show_night_thema),
            //night_thema_color: 'primary',
            show_language_panel: Boolean(data.show_language_panel),
            show_personal_profile_panel: Boolean(data.show_personal_profile_panel),
        
        //main profile view settings
            language_first: data.language_first,
            language_second: data.language_second,
            redirect_to_client_info: data.redirect_to_client_info,
            show_username_logo_fio: data.show_username_logo_fio, // ENUM
            Indicator_color_tabs: data.statistics_tab_color,
            messageWindow: this.location_alert(data.alert_location_first),
            messageConstantWindow: this.location_alert(data.alert_location_second),
            calendar_language_first: data.calendar_language_first,
            calendar_language_second: data.calendar_language_second,
            //username_logo_color: '#02527b',
            //button_schema: 'primary',
            //checkbox_schema: 'primary',
            //url_schema: 'primary',
            //button_text_color: 'white',
            //calendar_check_color: 'primary',
            //input_border_color: 'primary',
            //progress_bar_color: 'primary',
        
        //login
            login_show_main_logo: Boolean(data.login_show_main_logo),
            login_use_reset_password: Boolean(data.login_use_reset_password),
            login_input_type_view: data.login_input_type_view, //ENUM
            loginCardCode: loginMask.loginCardCode,
            loginPhoneNum: loginMask.loginPhoneNum,
            loginEmail: loginMask.loginEmail,
            Indicator_color_tabs_login: data.login_tab_color,
            login_card_mask: data.login_card_mask,
            login_phone_mask: data.login_phone_mask,
            //login_input_border_color: 'primary',
            //login_button_background_color: '#3f51b5',
            //login_button_text_color: '#ffffff',
           /* login_use_top_text: true,
            login_use_login_text: true,
            login_use_password_text: true,*/
        
        
        //statistics
            statistics_tabs_panel: Boolean(data.statistics_tabs_panel),
            statistics_second_tab_panel: Boolean(data.statistics_second_tab_panel),
            statistics_third_tab_panel: Boolean(data.statistics_third_tab_panel),
            statistics_fourth_tab_panel: Boolean(data.statistics_fourth_tab_panel),
            statistics_fifth_tab_panel: Boolean(data.statistics_fifth_tab_panel),
            statistics_swipe_for_PC: Boolean(data.statistics_swipe_for_PC),
            statistics_diagram_table: data.statistics_diagram_table, //ENUM ?????
            statistics_diagram_bonuses: Boolean(data.statistics_diagram_bonuses),
            statistics_barcode: Boolean(data.statistics_barcode),
            statistics_wallet_balances: Boolean(data.statistics_wallet_balances),
            statistics_consumption_meter: Boolean(data.statistics_consumption_meter),
            statistics_sales_table: Boolean(data.statistics_sales_table),
            statistics_cash_account: Boolean(data.statistics_cash_account),
            statistics_fuel_account: Boolean(data.statistics_fuel_account),
            statistics_fuel_tank_up: Boolean(data.statistics_fuel_tank_up),
            statistics_scroll_num: this.scroll_num(data.statistics_scroll_num), //ENUM
            statistics_column_width: data.statistics_column_width,
            statistics_category_to_display: data.statistics_category_to_display,
        
        //operations
            operations_rows_num: this.scroll_num(data.operations_rows_num), //ENUM,
        
        //clientInfo
            clientInfo_add_data: Boolean(data.clientInfo_add_data),
            clientInfo_profile_rule: data.clientInfo_profile_rule,//ENUM
            clientInfo_change_info: Boolean(data.clientInfo_change_info),
            clientInfo_activateCardOnProfileUpdateFromCustomerProfile: fetchdata.clientProfileSettings.activateCardOnProfileUpdateFromCustomerProfile,
        
        //security
            security_change_password: Boolean(data.security_change_password),
            security_change_card_block: Boolean(data.security_change_card_block),
            security_view_card_status: Boolean(data.security_view_card_status),
            security_change_card_pin: Boolean(data.security_change_card_pin), 
        
        //limits
            limits_table_view: Boolean(data.limits_table_view),
            limits_enable: data.limits_enable, //ENUM
            limits_statistics_view: Boolean(data.limits_statistics_view),
        
        //cashback
            cashback_sku_set_view: Boolean(data.cashback_sku_set_view),
            cashback_product_name_view: Boolean(data.cashback_product_name_view),
            cashback_sku_set_name_view: Boolean(data.cashback_sku_set_name_view),
            cashback_products_rows_num: this.scroll_num(data.cashback_products_rows_num),
            cashback_check_item_view: Boolean(data.cashback_check_item_view),
            cashback_end_notification_text: Boolean(data.cashback_end_notification_text),
            cashback_end_days_num: data.cashback_end_days_num,
            cashback_hide_rule_panel: data.cashback_hide_rule_panel, //ENUM
        }


        


//Custom стиль ===========================================>
    themeColorText = {
      color: data.text_color_schema
    };
    themeColorLogo = {
      color: data.username_logo_color,
      backgroundColor:'white'
    };
    /*var themeColorLogoMobile = {
      color: 'black',
      backgroundColor:'white'
    };*/
    themeColorLang = {
      color: data.night_thema_color
    };
    themeColorLink = {
      color: data.url_schema //'#3f51b5'
    };
    ThemeSwitch = withStyles({
      switchBase: {
        color: 'white',
        '&$checked': {
          color: data.night_thema_color,
        },
        '&$checked + $track': {
          backgroundColor: data.night_thema_color,
        },
      },
      checked: {},
      track: {},
    })(Switch);
    ThemeCheckbox = createMuiTheme({
      overrides: {
          MuiCheckbox: {
            colorPrimary:{
              color: '#9FA2B4',
              '&$checked': {
                color: data.checkbox_schema,
              },
              '&$disabled': {
                color: '#cfd1da',
              },
            },
          },
          MuiFormControlLabel: {
            label:
            {
              '&$disabled': {
                color: '#cfd1da',
              },
            }
          }

        }
  });
//прогрес бар
ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: '#9FA2B4',
  },
  barColorPrimary: {
    backgroundColor: data.progress_bar_color,   
  },
})(LinearProgress);

    //стиль элементов кнопок/ссылок .MuiTab-textColorPrimary-168.Mui-selected
    ThemeTab = createMuiTheme({
      
      overrides: {
          MuiTab:
          {
            textColorPrimary:{
              color: '#9FA2B4',
              '&$selected': {
                color: data.text_color_schema
              },
              },
            labelIcon:{
              paddingTop: 0
            },
          },
        }
  });

    ThemeClickElements = createMuiTheme({
        overrides: {
            MuiButton:
            {
              containedPrimary:
              {
                color: data.button_text_color, // цвет текста
                backgroundColor: data.button_schema, //цвет фона
                background: data.button_schema,
                "&:hover": {
                  //you want this to be the same as the backgroundColor above
                  color: data.button_text_color, // цвет текста
                  backgroundColor: data.button_schema, //цвет фона
                  filter: 'brightness(0.8)' //яркость
                },
                "&:disabled": {
                  //you want this to be the same as the backgroundColor above
                  color: 'white',
                  boxShadow: 'none',
                  backgroundColor: 'rgba(0, 0, 0, 0.12) !important',
                  background: 'rgba(0, 0, 0, 0.12) !important'
                }
              },
              outlinedPrimary:
              {
                color: '#fff',// цвет текста
                backgroundColor: '#3f51b5',//цвет фона
              },
              }
          }
    });
    ThemeAppBar = createMuiTheme({
      overrides: {
          MuiAppBar:
          {
            colorPrimary:
            {
              color: data.text_panel_color,
              backgroundColor: data.background_panel_color,
            },
        }
      }
  });

    var theme = createMuiTheme ({
        spacing: 1,
      });
    /*var borderColor =
    theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';*/

    //текстовое поле
    InputTextCustom = withStyles({
        root: {
            position: 'relative',
            '& $notchedOutline': {
              borderColor: '#9FA2B4',
            },
            '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
              borderColor: '',
              // Reset on touch devices, it doesn't add specificity
              '@media (hover: none)': {
                borderColor: '',
              },
            },
            '&$focused $notchedOutline': {
              borderColor: data.input_border_color,
              borderWidth: 2,
            },
            '&$error $notchedOutline': {
              borderColor: theme.palette.error.main,
            },
            '&$disabled $notchedOutline': {
              borderColor: '#9FA2B4',
            },
            marginTop: 1,
            marginLeft: 1,
          },
          
          /* Styles applied to the root element if the component is focused. */
          focused: {},
          /* Styles applied to the root element if 'disabled={true}'. */
          disabled: {},
          /* Styles applied to the root element if 'error={true}'. */
          error: {},
          /* Styles applied to the 'NotchedOutline' element. */
          notchedOutline: {},
    })(OutlinedInput);

    //Поля ввода даты/селекты/стиль модального окна
    materialThemeField = createMuiTheme({
        
        overrides: {
          MuiList: {
            padding: {
              paddingTop: 0,
              paddingBottom: 0,
            }
          },
          MuiPickersToolbar: {
            toolbar: {
              backgroundColor: data.calendar_check_color,
            },
          },
          MuiPickersCalendarHeader: {
            switchHeader: {
              // backgroundColor: lightBlue.A200,
              // color: "white",
            },

          },
          MuiTypography:{
            colorPrimary: {
              color: data.calendar_check_color
            }
          },
          MuiOutlinedInput:{
            root: {
              '& $notchedOutline': {
                  borderColor: '#9FA2B4',
                },
                '&$disabled $notchedOutline': {
                  borderColor: '#9FA2B4',
                },
                '&$focused $notchedOutline': {
                  borderColor: data.input_border_color,
                  borderWidth: 2,
                },
                
            }
        },
            MuiInput:{
              root:{
                '&$focused ': {
              }, 
              '&$underline:after': {
                borderBottomColor: data.input_border_color,
              },
              '&$underline:before': {
                borderBottomColor: '#9FA2B4',
              },
              }
          },
          MuiButton:
          {
              label:{
                color: data.calendar_check_color,
              }
          },
          MuiPickersDay: {
            day: {
              color: data.calendar_check_color,
            },
            daySelected: {
              backgroundColor: data.calendar_check_color,//calendar_check_color
              "&:hover": {
                //you want this to be the same as the backgroundColor above
                backgroundColor: data.calendar_check_color, //цвет фона
                filter: 'brightness(0.8)' //яркость
              },
            },
            dayDisabled: {
              color: '#9FA2B4',
            },
            current: {
              color: data.calendar_check_color,
            },
          },
          MuiPickersModal: {
            dialogAction: {
              color: '#3f51b5',
            },
          },
        },
      });


//Custom стиль для Login ===========================================>
        ThemeTabLogin = createMuiTheme({
                    
          overrides: {
              MuiTab:
              {
                textColorPrimary:{
                  color: '#9FA2B4',
                  '&$selected': {
                    color: data.login_tab_color
                  },
                  },
                labelIcon:{
                  paddingTop: 0
                },
              },
            }
        });
      ThemeButton = createMuiTheme({
        overrides: {
            MuiButton:
            {
              containedPrimary:
              {
                background: data.login_button_background_color,
                color: data.login_button_text_color, // цвет текста
                backgroundColor: data.login_button_background_color, //цвет фона
                "&:hover": {
                  //you want this to be the same as the backgroundColor above
                  color: data.login_button_text_color + "!important", // цвет текста
                  backgroundColor: data.login_button_background_color + "!important", //цвет фона
                  filter: 'brightness(0.8)' //яркость
                },
                "&:disabled": {
                  //you want this to be the same as the backgroundColor above
                  color: 'white',
                  boxShadow: 'none',
                  backgroundColor: 'rgba(0, 0, 0, 0.12)',
                  background: 'rgba(0, 0, 0, 0.12) !important'
                }
              },
              outlinedPrimary:
              {
                color: '#fff',// цвет текста
                backgroundColor: '#3f51b5',//цвет фона
              },
              }
          }
      });
        //текстовое поле
        CssTextField = withStyles({
          root: {
            width: 320,
            '& label.Mui-focused': {
              color: '',
            },

            '& .MuiInput-underline:after': {
              borderBottomColor: data.login_input_border_color,            
              },
            '& .MuiInput-underline:before': {
                borderColor: '#9FA2B4',            
              },

            '& .MuiFilledInput-underline:after': {
              borderBottomColor: data.login_input_border_color,
            },
            '& .MuiFilledInput-underline:before': {
              borderBottomColor: '#9FA2B4',
            },

            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#9FA2B4',
              },
              '&:hover fieldset': {
                borderColor: '',
              },
              '&.Mui-focused fieldset': {
                borderColor: data.login_input_border_color,
              },
            },
          },
        })(TextField);
        
    }

    //Локализация
    componentWillMount() {
        var language = localStorage.getItem('language') == null ? "uk":localStorage.getItem('language');
        this.setLanguage(language);
        localStorage.setItem('language', language);

        this.setState({theme: localStorage.getItem('theme') == null ? "light":localStorage.getItem('theme')})
      }
    setLanguage(language) {
        i18next.init({
          lng: language,
          resources: require(`./${language}.json`)
        });
      }

    //Тема
    toggleTheme() {
        const theme = this.state.theme === "light" ? "dark" : "light";
        document.documentElement.classList.add("color-theme-in-transition");
        localStorage.setItem('theme', theme);
        this.setState({ theme: theme});
        document.documentElement.setAttribute("data-theme", theme);
        window.setTimeout(() => {
            document.documentElement.classList.remove("color-theme-in-transition");
        }, 1000);
    }
    switchArticle(id) {
        this.setState({ activeArticleId: id });
    }

    //Авторизация
    componentDidMount() {
      var token = new URLSearchParams(window.location.search).get("token")
      if(token != null)
        {
        const requestOptionsExit = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify("")
          }
          fetch(`/api/login/`+ token, requestOptionsExit)
          .then((response) => {
              if(response.status == 500)
              {
                  messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                  this.setState({key: Math.random()})
              }
              return response.json()})
          .then((response) => {
              if(response.error)
              { 
                  messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                  this.setState({message: response.error, key: Math.random()})
              }else if(response.data)
              {
                  messageWindow.OpenMessage("info", localization.GetTranslate(response.data))
                  this.setState({message: response.data, isLoaded: true, key: Math.random()})
              }          
          })  
        }
        const requestOptionsExit = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify("")
          }
          fetch(`/api/getsettings`, requestOptionsExit)
          .then((response) => {
              if(response.status == 500)
              {
                  alert("Settings not loaded. Default settings applied. Error: "+response.status +" "+ response.statusText);
                  this.setState({settingsIsLoad: true})
              }
              return response.json()})
          .then((response) => {
                var fetchdata  = JSON.parse(response.data);
                //console.log(fetchdata)
                if(fetchdata != null || fetchdata != undefined)
                {
                  var data = fetchdata.clientProfileSettings.newPersonalProfileSettingsForm;
                  var loginMask = {
                    loginCardCode: Boolean(fetchdata.clientProfileSettings.loginCardCode),
                    loginPhoneNum: Boolean(fetchdata.clientProfileSettings.loginPhoneNum),
                    loginEmail: Boolean(fetchdata.clientProfileSettings.loginEmail),
                  }
                  //применение новых настроек
                  if(data != null || data != undefined)
                  {
                    
                    localization.dataSetTranslate(data);
                    this.MethodAppliedSettings(fetchdata,data,loginMask)
                  }
                }
                this.setState({settingsIsLoad: true})
          })

          authenticationService.currentUser.subscribe(x => this.setState({ currentUser: x }));

        document.documentElement.setAttribute("data-theme", this.state.theme);
        window.setTimeout(() => {
            document.documentElement.classList.remove("color-theme-in-transition");
        }, 1000);
        
    }
    logout() {
        authenticationService.logout();
        history.push('/login');
    }
    setSelectedIndex(index)
    {
      const {selectedIndex} = this.state;
      if(selectedIndex !== index) this.setState({selectedIndex: index});
    }
    render() {
        const { currentUser,settingsIsLoad, selectedIndex} = this.state;
        // console.log(currentUser)
        return (    
            <Router history={history}>   
                <div>
                    <div>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6 offset-md-3">
                                    {!settingsIsLoad &&
                                    <div className="preloaderSetttings"></div> 
                                    }
                                    <ThemeProvider theme={ThemeClickElements}>
                                        {currentUser &&
                                          <div key={selectedIndex}>
                                            {selectedIndex !== -1 &&
                                              <Navigation selectedIndex={selectedIndex} key={this.state.keyFixed} theme={this.state.theme} settings={AppliedSettings} user={currentUser} changeTheme={this.toggleTheme}></Navigation>
                                            }
                                          </div>
                                        }
                                        {AppliedSettings.show_statistics_page && <PrivateRoute exact path={baseUrl + "/"} setSelectedIndex={this.setSelectedIndex} component={Stats} />}
                                        {AppliedSettings.show_statistics_page && <PrivateRoute exact path={baseUrl + "/stats"} setSelectedIndex={this.setSelectedIndex} component={Stats} />}
                                        {AppliedSettings.show_operations_page && <PrivateRoute exact path={baseUrl + "/operations"} setSelectedIndex={this.setSelectedIndex} component={Operations}/>}
                                        {AppliedSettings.show_clientInfo_page && <PrivateRoute exact path={baseUrl + "/clientInfo"} setSelectedIndex={this.setSelectedIndex} closefixedMessage={this.closefixedMessage} updateUserName={this.updateUserName} component={ClientInfo} />}
                                        {AppliedSettings.show_security_page && <PrivateRoute exact path={baseUrl + "/security"} setSelectedIndex={this.setSelectedIndex} component={Security}/>}
                                        {AppliedSettings.show_limits_page && <PrivateRoute exact path={baseUrl + "/limits"} setSelectedIndex={this.setSelectedIndex} component={Limits} />}
                                        {AppliedSettings.show_cashback_page && <PrivateRoute exact path={baseUrl + "/cashback"} setSelectedIndex={this.setSelectedIndex} component={Cashback} />}
                                        {<PrivateRoute exact path={baseUrl + "/about"} component={({location}) => <About setSelectedIndex={this.setSelectedIndex} theme={this.state.theme} location={location}></About>}/>}
                                    </ThemeProvider>
                                    <ThemeProvider theme={ThemeButton}>
                                        <Route path={baseUrl + "/login"} component={({location}) => <Login setSelectedIndex={this.setSelectedIndex} theme={this.state.theme} key={this.state.key} AppliedSettings={AppliedSettings} location={location} history={history}></Login>} />
                                    </ThemeProvider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Router>
        );
    }
}
var AppliedSettings = {
  //view_navigation_settings
      show_statistics_page: true,
      show_operations_page: true,
      show_clientInfo_page: true,
      show_security_page: true,
      show_limits_page: true,
      show_cashback_page: true,
      show_night_thema: true,
      //night_thema_color: 'primary',
      show_language_panel: true,
      show_personal_profile_panel: true,
  
  //main profile view settings
      language_first: "Укр",
      language_second: "Рус",
      redirect_to_client_info: true,
      show_username_logo_fio: 0, 
      //text_panel_color: "#FFF",
      //background_panel_color: "#3f51b5",
      Indicator_color_tabs: '#3f51b5',
      messageWindow: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      messageConstantWindow: {
        vertical: 'bottom',
        horizontal: 'right',
      },
      calendar_language_first: 0,
      calendar_language_second: 1,
      //username_logo_color: '#02527b',
      //text_color_schema: '#2196F3',
      //button_schema: 'primary',
      //checkbox_schema: 'primary',
      //url_schema: 'primary',
      //button_text_color: 'white',
      //calendar_check_color: 'primary',
      //input_border_color: 'primary',
      //progress_bar_color: 'primary',
  
  //login
      login_show_main_logo: true,
      login_use_reset_password: true,
      login_input_type_view: 2,
      loginCardCode: true,
      loginPhoneNum: false,
      loginEmail: false,
      Indicator_color_tabs_login: "#3f51b5",
      login_card_mask: "xxxx - xxxx - xxxx - xxxx",
      login_phone_mask: "+38(xxx) xxx - xx - xx",
      //login_input_border_color: '',
      //login_button_background_color: '#3f51b5',
      //login_button_text_color: '#ffffff',
     /* login_use_top_text: true,
      login_use_login_text: true,
      login_use_password_text: true,*/
  
  
  //statistics
      statistics_tabs_panel: true,
      statistics_second_tab_panel: true,
      statistics_third_tab_panel: true,
      statistics_fourth_tab_panel: true,
      statistics_fifth_tab_panel: true,
      statistics_swipe_for_PC: true,
      statistics_diagram_table: 0,
      statistics_diagram_bonuses: true,
      statistics_barcode: true,
      statistics_wallet_balances: true,
      statistics_consumption_meter: true,
      statistics_sales_table: true,
      statistics_cash_account: true,
      statistics_fuel_account: true,
      statistics_fuel_tank_up: true,
      statistics_scroll_num: 10,
      statistics_column_width: 18,
      statistics_category_to_display: 0,
  
  //operations
      operations_rows_num: 10,
  
  //clientInfo
      clientInfo_add_data: true,
      clientInfo_profile_rule: 0,//ENUM
      clientInfo_change_info: false,
      clientInfo_activateCardOnProfileUpdateFromCustomerProfile: 1,
  
  //security
      security_change_password: true,
      security_change_card_block: true,
      security_view_card_status: true,
      security_change_card_pin: true, 
  
  //limits
      limits_table_view: true,
      limits_enable: 7, //ENUM
      limits_statistics_view: true,
  
  //cashback
      cashback_sku_set_view: true,
      cashback_product_name_view: true,
      cashback_sku_set_name_view: true,
      cashback_products_rows_num: 10,
      cashback_check_item_view: true,
      cashback_end_notification_text: true,
      cashback_end_days_num: 7,
      cashback_hide_rule_panel: 0, //ENUM 
  }

//стиль по умолчанию ===========================================>
    var themeColorText = {
      color: '#2196F3'
    };
    var themeColorLogo = {
      color: '#02527b',
      backgroundColor:'white'
    };
    /*var themeColorLogoMobile = {
      color: 'white',
      backgroundColor:'white'
    };*/
    var themeColorLang = {
      color: '#3f51b5'
    };
    var themeColorLink = {
      color: '#3f51b5'
    };
  
    var ThemeSwitch = withStyles({
      switchBase: {
        color: 'white',
        '&$checked': {
          color: '#3f51b5',
        },
        '&$checked + $track': {
          backgroundColor: '#3f51b5',
        },
      },
      checked: {},
      track: {},
    })(Switch);
    var ThemeCheckbox = createMuiTheme({
      overrides: {
          MuiCheckbox: {
            colorPrimary:{
              color: '#9FA2B4',
              '&$checked': {
                color: '#3f51b5',
              },
              '&$disabled': {
                color: '#cfd1da',
              },
            },
          },
          MuiFormControlLabel: {
            label:
            {
              '&$disabled': {
                color: '#cfd1da',
              },
            }
          }

        }
  });
//прогрес бар
var ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: '',
  },
  barColorPrimary: {
    backgroundColor: '',
  },
})(LinearProgress);

    //стиль элементов кнопок/ссылок .MuiTab-textColorPrimary-168.Mui-selected
    var ThemeTab = createMuiTheme({
      
      overrides: {
          MuiTab:
          {
            textColorPrimary:{
              color: '#9FA2B4',
              '&$selected': {
                color: '#2196F3'
              },
              },
            labelIcon:{
              paddingTop: 0
            },
          },
        }
  });

    var ThemeClickElements = createMuiTheme({
        overrides: {
            MuiButton:
            {
              containedPrimary:
              {
                color: '#fff', // цвет текста
                backgroundColor: '#3f51b5', //цвет фона
                "&:hover": {
                  //you want this to be the same as the backgroundColor above
                  color:'#fff', // цвет текста
                  backgroundColor: "#3f51b5", //цвет фона
                  filter: 'brightness(0.8)' //яркость
                },
                "&:disabled": {
                  //you want this to be the same as the backgroundColor above
                  color: 'white',
                  boxShadow: 'none',
                  backgroundColor: 'rgba(0, 0, 0, 0.12)',
                }
              },
              outlinedPrimary:
              {
                color: '#fff',// цвет текста
                backgroundColor: '#3f51b5',//цвет фона
              },
              }
          }
    });
    var ThemeAppBar = createMuiTheme({
      overrides: {
          MuiAppBar:
          {
            colorPrimary:
            {
              color: '#fff',
              backgroundColor: '#3f51b5',
            },
        }
      }
  });

    var theme = createMuiTheme ({
        spacing: 1,
      });
    /*var borderColor =
    theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';*/

    //текстовое поле
    var InputTextCustom = withStyles({
        root: {
            position: 'relative',
            '& $notchedOutline': {
              borderColor: '#9FA2B4',
            },
            '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
              borderColor: '',
              // Reset on touch devices, it doesn't add specificity
              '@media (hover: none)': {
                borderColor: '',
              },
            },
            '&$focused $notchedOutline': {
              borderColor: '',
              borderWidth: 2,
            },
            '&$error $notchedOutline': {
              borderColor: theme.palette.error.main,
            },
            '&$disabled $notchedOutline': {
              borderColor: '#9FA2B4',
            },
            marginTop: 1,
            marginLeft: 1,
          },
          
          /* Styles applied to the root element if the component is focused. */
          focused: {},
          /* Styles applied to the root element if 'disabled={true}'. */
          disabled: {},
          /* Styles applied to the root element if 'error={true}'. */
          error: {},
          /* Styles applied to the 'NotchedOutline' element. */
          notchedOutline: {},
    })(OutlinedInput);

    //Поля ввода даты/селекты/стиль модального окна
    var materialThemeField = createMuiTheme({
        
        overrides: {
          MuiList: {
            padding: {
              paddingTop: 0,
              paddingBottom: 0,
            }
          },
          MuiPickersToolbar: {
            toolbar: {
              backgroundColor: '#3f51b5',
            },
          },
          MuiPickersCalendarHeader: {
            switchHeader: {
              // backgroundColor: lightBlue.A200,
              // color: "white",
            },
          },
          MuiOutlinedInput:{
            root: {
              '& $notchedOutline': {
                  borderColor: '#9FA2B4',
                },
                '&$disabled $notchedOutline': {
                  borderColor: '#9FA2B4',
                },
            }
        },
          MuiButton:
          {
              label:{
                color: '#3f51b5',
              }
          },
          MuiPickersDay: {
            day: {
              color: '#3f51b5',
            },
            daySelected: {
              backgroundColor: '#3f51b5',
              "&:hover": {
                //you want this to be the same as the backgroundColor above
                backgroundColor: '#3f51b5', //цвет фона
                filter: 'brightness(0.8)' //яркость
              },
            },
            dayDisabled: {
              color: '#9FA2B4',
            },
            current: {
              color: '#3f51b5',
            },
          },
          MuiPickersModal: {
            dialogAction: {
              color: '#3f51b5',
            },
          },
        },
      });


//Custom стиль для страницы Login ===========================================>
      var ThemeTabLogin = createMuiTheme({
            
        overrides: {
            MuiTab:
            {
              textColorPrimary:{
                color: '#9FA2B4',
                '&$selected': {
                  color: '#2196F3'
                },
                },
              labelIcon:{
                paddingTop: 0
              },
            },
          }
      });
      var ThemeButton = createMuiTheme({
        overrides: {
            MuiButton:
            {
              containedPrimary:
              {
                color: 'white', // цвет текста
                backgroundColor: '#3f51b5', //цвет фона
                "&:hover": {
                  //you want this to be the same as the backgroundColor above
                  color: 'white', // цвет текста
                  backgroundColor: '#3f51b5', //цвет фона
                  filter: 'brightness(0.8)' //яркость
                },
                "&:disabled": {
                  //you want this to be the same as the backgroundColor above
                  color: 'white',
                  boxShadow: 'none',
                  backgroundColor: 'rgba(0, 0, 0, 0.12)',
                }
              },
              outlinedPrimary:
              {
                color: '#fff',// цвет текста
                backgroundColor: '#3f51b5',//цвет фона
              },
              }
          }
      });
      var useStyles = {
        LoginPosition: {
          margin: "auto",
        },
        LoginForm: {
            margin: 'auto',
            textalign: 'center',
        },
      };
        //текстовое поле
        var CssTextField = withStyles({
          root: {
            width: 320,
            '& label.Mui-focused': {
              color: '',
            },
            '& .MuiInput-underline:after': {
              borderBottomColor: '#3f51b5',
            },
            '& .MuiInput-underline:before': {
              borderColor: '#9FA2B4',            
            },

            '& .MuiFilledInput-underline:after': {
              borderBottomColor: '#3f51b5',
            },
            '& .MuiFilledInput-underline:before': {
              borderBottomColor: '#9FA2B4',
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#9FA2B4',
              },
              '&:hover fieldset': {
                borderColor: '',
              },
              '&.Mui-focused fieldset': {
                borderColor: AppliedSettings.login_input_border_color,
              },
            },
          },
        })(TextField);
        /*
        MuiOutlinedInput:{
            root: {
              '& $notchedOutline': {
                  borderColor: '#9FA2B4',
                },
                '&$disabled $notchedOutline': {
                  borderColor: '#9FA2B4',
                },
            }
        },
        */
export { ThemeButton, useStyles, CssTextField };
export { 
    themeColorText,
    themeColorLogo,
    themeColorLang,
    themeColorLink,
    ThemeAppBar,
    ThemeSwitch, 
    ThemeCheckbox, 
    ThemeTab,
    ThemeTabLogin,
    ColorLinearProgress,
    InputTextCustom,
    materialThemeField, 
    ThemeClickElements,
    AppliedSettings };
export default App;
export {App};
